import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OnboardingService } from 'src/app/shared/service/onboarding.service';
import { OnboardOTP } from 'src/app/shared/models/OnboardOTP';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-onboard-activation',
  templateUrl: './onboard-activation.component.html',
  styleUrls: ['./onboard-activation.component.css']
})
export class OnboardActivationComponent implements OnInit {
  text:boolean;
  slug:string;
  error: string;
  exception: boolean;
  _onboardOTP:OnboardOTP;
  constructor(private route: ActivatedRoute,private _onboardingService: OnboardingService,public router: Router,private toastr: ToastrService) { }
  ngOnInit() {
    this.text=false;
    this._onboardOTP=new OnboardOTP();
    this.route.params.subscribe(params => {
      this.slug = params['slug'];
      this._onboardOTP.Slug = this.slug;
    });
  }
  activate(){
    this._onboardingService.validateOTP(this._onboardOTP).
      subscribe((data: any) => {
        this.error = "";
        //this.hrSvc.saveEmpDetails(this.HREmp.employeeDetails)
        if(data.Success==true){
          this.exception = false;
          this.text=false;
          localStorage.setItem('slug', this._onboardOTP.Slug);
          this.router.navigateByUrl("/onboarding/"+this._onboardOTP.Slug);
        }else{
          this.exception = true;
          this.error = data.ErrorMessage;
        }
      },
        error => this.error = error);
  }
  generateOTP(){
    this.error="Wait for few seconds...."
    this._onboardingService.generateOTP(this.slug,"").
      subscribe((data: any) => {
        this.error = "";
        if(data.Success==true){
          this.exception = false;
          this.text=true;
          this.toastr.success("OTP is sent to your registered mobile number");

        }else{
          this.exception = true;
          this.error = data.ErrorMessage;
          this.toastr.warning(this.error);
        }
      },
        error => this.error = error);
  }
}
